/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * WordPress dependencies
 */
import {
	ToggleGroupControl,
	ToggleGroupControlOptionIcon,
} from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';
import {
	reset,
	formatCapitalize,
	formatLowercase,
	formatUppercase,
} from '@safe-wordpress/icons';

const TEXT_TRANSFORMS = [
	{
		label: _x( 'None', 'text', 'nelio-ab-testing' ),
		value: 'none',
		icon: reset,
	},
	{
		label: _x( 'Uppercase', 'text', 'nelio-ab-testing' ),
		value: 'uppercase',
		icon: formatUppercase,
	},
	{
		label: _x( 'Lowercase', 'text', 'nelio-ab-testing' ),
		value: 'lowercase',
		icon: formatLowercase,
	},
	{
		label: _x( 'Capitalize', 'text', 'nelio-ab-testing' ),
		value: 'capitalize',
		icon: formatCapitalize,
	},
];

/**
 * Control to facilitate text transform selections.
 *
 * @param {Object}   props           Component props.
 * @param {string}   props.className Class name to add to the control.
 * @param {string}   props.value     Currently selected text transform.
 * @param {Function} props.onChange  Handles change in text transform selection.
 *
 * @return {Element} Text transform control.
 */
type TextTransformControlProps = {
	readonly className?: string;
	readonly value?: string;
	readonly onChange: ( value?: string | number ) => void;
	readonly disabled?: boolean;
};
export function TextTransformControl( {
	className,
	value,
	disabled,
	onChange,
}: TextTransformControlProps ): JSX.Element {
	return (
		<ToggleGroupControl
			isDeselectable
			__nextHasNoMarginBottom
			__next40pxDefaultSize
			label={ _x( 'Letter case', 'text', 'nelio-ab-testing' ) }
			className={ clsx(
				'block-editor-text-transform-control',
				className
			) }
			value={ value }
			onChange={ ( newValue ) => {
				onChange( newValue === value ? undefined : newValue );
			} }
		>
			{ TEXT_TRANSFORMS.map( ( option ) => {
				return (
					<ToggleGroupControlOptionIcon
						key={ option.value }
						value={ option.value }
						icon={ option.icon }
						label={ option.label }
						disabled={ disabled }
					/>
				);
			} ) }
		</ToggleGroupControl>
	);
}
